import React from "react";

const StepNextArrowIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32.291"
      height="12.332"
      viewBox="0 0 32.291 12.332"
    >
      <g
        id="Group_1158"
        data-name="Group 1158"
        transform="translate(-483 -190.668)"
      >
        <g
          id="arrow_nxt"
          transform="translate(496 190.668)"
          opacity={!fill ? "0.24" : ""}
        >
          <path
            id="Path_341"
            data-name="Path 341"
            d="M2202.948,3205.042a.9.9,0,0,1,.1.1l.048.069.044.079a1.524,1.524,0,0,1,.065.147l.027.086a1.667,1.667,0,0,1,0,.9l-.027.085a1.529,1.529,0,0,1-.065.147l-.044.079-.048.069a.9.9,0,0,1-.1.1l-5.6,5.09c-.325.3-.743.12-.932-.394a1.469,1.469,0,0,1,.254-1.469l3.391-3.083h-15.383c-.377,0-.682-.483-.682-1.075s.3-1.076.682-1.076h15.383l-3.391-3.083a1.469,1.469,0,0,1-.254-1.469c.188-.514.606-.692.932-.394Z"
            transform="translate(-2184 -3199.808)"
            fill={fill ? fill : "#404040"}
          />
        </g>
        <g
          id="Rectangle_3497"
          data-name="Rectangle 3497"
          transform="translate(488 196)"
          fill="none"
          stroke={fill ? fill : "#c8c8c8"}
          strokeWidth="1"
        >
          <rect width="6" height="2" rx="1" stroke="none" />
          <rect x="0.5" y="0.5" width="5" height="1" rx="0.5" fill="none" />
        </g>
        <g
          id="Rectangle_3498"
          data-name="Rectangle 3498"
          transform="translate(483 196)"
          fill="none"
          stroke={fill ? fill : "#c8c8c8"}
          strokeWidth="1"
        >
          <rect width="3" height="2" rx="1" stroke="none" />
          <rect x="0.5" y="0.5" width="2" height="1" rx="0.5" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default StepNextArrowIcon;
